
import { isEmpty, round } from 'es-toolkit/compat';

/**
 * Converts meters to miles, rounding to 1 decimal place.
 */
export function metersToMiles(meters: number): number {
  return round(meters / 1610, 1);
}

/**
 * Converts meters to kilometers, rounding to 1 decimal place.
 */
export function metersToKilometers(meters: number): number {
  return round(meters / 1000, 1);
}

/**
 * @param countryCode the 2 character country code
 */
export function unitsForCountry(countryCode?: string): 'miles' | 'km' {
  switch (countryCode) {
    case 'US':
    case 'GB':
    case 'NI':
    case 'WAL':
    case 'WS':
      return 'miles';
    default:
      return 'km';
  }
}

/**
 * @param countryCode the 2 character country code
 */
export function unitsForLocale(locale?: string): 'miles' | 'km' {
  if (isEmpty(locale)) {
    return 'miles';
  }
  switch (locale?.toLowerCase()) {
    case 'en-us':
    case 'en-gb':
      return 'miles';
    default:
      return 'km';
  }
}
